import React, { useRef } from 'react';
// Import custom hooks
import useStepLogic from 'components/Form/useStepLogic';
// Import components
import SectionStepInfo from 'components/shared/SectionStepInfo/SectionStepInfo';
import useFormData from '../../../useFormData';
import EventName from './EventName/EventName';
import Date from './Date/Date';
import Address from './Address/Address';
import Description from './Description/Description';
import Invitation from './Invitation/Invitation';

const Event = () => {
  const formRef = useRef(); // Used so we can keep track of the form DOM element
  const { handleSubmit, showGenericError, continueButton } = useStepLogic(formRef); // Custom hook for handling continue button (validation, errors etc)

  // Check it we are facing an existing user
  const { ExistingUser } = useFormData();

  return (
    <form onSubmit={handleSubmit} ref={formRef} autoComplete="on">
      {/* Subsection */}
      {!ExistingUser && <SectionStepInfo section="Section 2 of 4" description="About you" />}

      {/* Show generic error message */}
      {showGenericError}

      <fieldset className="wmcads-fe-fieldset wmcads-col-1">
        <legend className="wmcads-fe-fieldset__legend">
          <h2 className="wmcads-fe-question">What event would you like to invite the Mayor to?</h2>
        </legend>

        <EventName />
        <Date />
        <Address />
        <Description />
        <Invitation />
      </fieldset>

      {/* Continue button */}
      {continueButton()}
    </form>
  );
};

export default Event;
